const formatAmount = (row) => {
  if (!row.amount_in || !row.amount_out) {
    return 0;
  }

  const amountIn = parseFloat(row.amount_in);
  const amountOut = parseFloat(-row.amount_out);

  if (amountIn > 0) {
    return amountIn;
  }

  return amountOut;
};

const getStockLedgerItems = (stockLedger, stockId) =>
  stockLedger.filter((item) => item.stock_id === stockId);

const getStockGroups = (productGroups, productId) =>
  productGroups.filter((group) => group.product_id === productId);

const getStockItems = (productStock, groupId) =>
  productStock
    .filter((item) => item.group_id === groupId)
    .map((item) => ({ stockId: item.stock_id, quantity: item.quantity }));

const getRequiredStockForProductAndQuantity = (
  productStock,
  productGroups,
  { id, quantity }
) =>
  getStockGroups(productGroups, id)
    .reduce(
      (agg, group) => [...agg, ...getStockItems(productStock, group.id)],
      []
    )
    .reduce((agg, item) => {
      return [
        ...agg,
        { ...item, totalQuantity: parseFloat(item.quantity) * quantity },
      ];
    }, []);

export const getRequiredStock = (
  orders,
  orderItems,
  productStock,
  productGroups
) =>
  orders
    .map((order) => orderItems.filter((item) => item.orders_id === order.id))
    .map((items) =>
      items
        .map((item) =>
          getRequiredStockForProductAndQuantity(productStock, productGroups, {
            id: item.product_id,
            quantity: parseFloat(item.quantity),
          })
        )
        .reduce((agg, item) => {
          return [...agg, ...item];
        }, [])
    )
    .reduce((agg, item) => {
      return [...agg, ...item];
    }, [])
    .reduce((agg, item) => {
      const existing = agg[item.stockId] ?? 0;
      const updated = existing + item.totalQuantity;

      return { ...agg, [item.stockId]: updated };
    }, {});

const getPurchaseItems = (purchaseItems, purchase) =>
  purchaseItems.filter(({ purchase_id }) => purchase_id === purchase.id);

export const getPendingStock = (purchases, purchaseItems) =>
  purchases
    .reduce(
      (agg, purchase) =>
        Boolean(purchase.is_complete)
          ? agg
          : [...agg, ...getPurchaseItems(purchaseItems, purchase)],
      []
    )
    .reduce((agg, item) => {
      const existing = agg[item.stock_id] ?? 0;
      const updated = existing + parseFloat(item.quantity);

      return { ...agg, [item.stock_id]: updated };
    }, {});

export const getLevels = (
  stockLedger,
  requiredStock,
  pendingStock,
  stockId
) => {
  const data = getStockLedgerItems(stockLedger, stockId);

  let totalIn = 0;
  let totalOut = 0;
  let currentLevel = 0;

  data.forEach((item) => {
    const amount = formatAmount(item);
    if (amount > 0) {
      totalIn = totalIn + amount;
    } else {
      totalOut = totalOut + amount;
    }
    currentLevel = currentLevel + amount;
  });

  const requiredLevel = -(requiredStock[stockId] ?? 0);
  const pendingLevel = pendingStock[stockId] ?? 0;

  return {
    totalIn,
    totalOut,
    requiredLevel,
    pendingLevel,
    futureLevel: currentLevel + pendingLevel + requiredLevel,
    currentLevel,
  };
};
